import Image from "next/image";

import { cn } from "@/shared/lib/utils/cn";

export function AunixLogo({
  className,
  width = 114,
  height = 24,
  priority = false,
}: {
  className?: string;
  width?: number;
  height?: number;
  priority?: boolean;
}) {
  return (
    <Image
      src="/figma-assets/aunix-logo.png"
      alt="Aunix"
      width={width}
      height={height}
      className={cn("h-6 w-auto", className)}
      style={{ width: "auto" }}
      priority={priority}
    />
  );
}
